import { render, staticRenderFns } from "./HomePageSkeleton.vue?vue&type=template&id=efca5f90&scoped=true"
import script from "./HomePageSkeleton.vue?vue&type=script&lang=js"
export * from "./HomePageSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efca5f90",
  null
  
)

export default component.exports